import { render } from "./ShadowImage.vue?vue&type=template&id=5938c99e"
const script = {}
script.render = render

export default script